(function () {
  angular
    .module('specsguardApp')
    .directive('sgModulesTreeviewList', sgModulesTreeview);

  sgModulesTreeview.$inject = [];

  function sgModulesTreeview () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-modules-treeview/sg-modules-treeview.html',
      controller: 'sgModulesTreeviewCtrl',
    };
  }
})();
